import { setCookie, getCookieValue } from '../helpers/cookie';

export default function adBanner() {
  const adBannerEl = document.querySelector('.ad-banner');

  if (!adBannerEl) {
    return;
  }

  document.body.classList.add('is-banner-visible');
  const adBannerCloseBtn = adBannerEl.querySelector('#banner-close-btn');

  if (!adBannerCloseBtn) return;

  adBannerCloseBtn.addEventListener('click', () => {
    adBannerEl.remove();
    document.body.classList.remove('is-banner-visible');
    setCookie('isBannerClosed', true, 365);
  });

  window.addEventListener('pageshow', () => {
    if (getCookieValue('isBannerClosed') === 'true') {
      const bannerEl = document.querySelector('.ad-banner');
      if (bannerEl) {
        bannerEl.remove();
        document.body.classList.remove('is-banner-visible');
      }
    }
  });
}
